import { render, staticRenderFns } from "./Relatorio-exportar.vue?vue&type=template&id=836e5472&"
import script from "./Relatorio-exportar.vue?vue&type=script&lang=js&"
export * from "./Relatorio-exportar.vue?vue&type=script&lang=js&"
import style0 from "./Relatorio-exportar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports